export type TipoIdentificacionItem = {
    s_codigo: string;
    s_descripcion: string;
};

const toArray = <T,>(value: T | T[] | undefined | null): T[] => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
};

const mapTipoIdentificacionItem = (item: any): TipoIdentificacionItem => ({
    s_codigo: String(item?.s_codigo ?? item?.ICodigo ?? item?.iCodigo ?? ''),
    s_descripcion: String(item?.s_descripcion ?? item?.SDescripcion ?? item?.sDescripcion ?? ''),
});

export const extractTiposIdentificacion = (response: any): TipoIdentificacionItem[] => {
    const lstTiposIdent =
        response?.payload?.data?.LstTiposIdent
        ?? response?.payload?.LstTiposIdent
        ?? response?.LstTiposIdent;

    if (!lstTiposIdent) {
        return [];
    }

    const normalized = toArray(lstTiposIdent.Datos_TiposIdentificacion).map(mapTipoIdentificacionItem);
    if (normalized.length > 0) {
        return normalized.filter((item) => item.s_codigo && item.s_descripcion);
    }

    return toArray(lstTiposIdent.TipoIdentificacionDTO)
        .map(mapTipoIdentificacionItem)
        .filter((item) => item.s_codigo && item.s_descripcion);
};

export const getDefaultTipoIdentificacionCodigo = (tipos: TipoIdentificacionItem[]): string => {
    const cedula = tipos.find((item) => item.s_descripcion.toUpperCase() === 'CEDULA');
    return cedula?.s_codigo ?? tipos[0]?.s_codigo ?? '';
};

/** Fallback CACMPU cuando aún no llega el WS */
const FALLBACK_TIPOS_IDENTIFICACION: Record<string, string> = {
    '1': 'CEDULA',
    '2': 'RUC',
    '3': 'PASAPORTE',
    '4': 'POBLACION INDIGENA',
    '5': 'EXTRANJERO',
    '6': 'PANAMEÑO NATURALIZADO',
    '7': 'PANAMEÑO EXTRANJERO',
    '8': 'PANAMEÑOS NACIDOS ANTES VIGENCIA',
    '10': 'XXXXXX',
    // Compatibilidad catálogo Colombia (otros clientes)
    '13': 'CEDULA',
    '22': 'CEDULA EXTRANJERIA',
    '31': 'NIT',
    '41': 'PASAPORTE',
    '61': 'PASAPORTE',
};

export const getTipoIdentificacionDescripcion = (
    codigo: string | number | undefined | null,
    tipos: TipoIdentificacionItem[] = [],
): string => {
    const code = String(codigo ?? '').trim();
    if (!code) return '';

    const fromWs = tipos.find((item) => String(item.s_codigo) === code);
    if (fromWs?.s_descripcion) {
        return fromWs.s_descripcion;
    }

    return FALLBACK_TIPOS_IDENTIFICACION[code] ?? '';
};
